<template>
  <!--成员管理-->
  <div class="member info-con" @click="closePopver">
    <div class="tmp-title nav-title">
      <div class="tt-left">
        <h2>成员管理</h2>
      </div>
    </div>
    <div class="member-info">
      <div class="mi-left">
        <div class="mil-title">
          <el-tooltip
            :content="loginInfo.current_team_id && loginInfo.current_team_name"
            placement="top"
            effect="light"
          >
            <h3 class="text-hidden">
              {{ loginInfo.current_team_id && loginInfo.current_team_name }}
            </h3>
          </el-tooltip>
          <img
            src="../../../../assets/image/edit.png"
            alt=""
            class="team-name-edit"
            @click="renameOpen"
            v-if="loginInfo.current_team_role === 1"
          />
        </div>

        <p>
          共
          {{ loginInfo.current_team_id && loginInfo.current_team_members }}
          位成员，剩余{{
            loginInfo.current_team_id && current_team_info.members && 
            current_team_info.members - current_team_info.members_use
          }}个名额

          <a
            href="javascript:;"
            class="team-upgrade"
            v-if="!current_team_info.corp_id"
            @click="levelDialogStatus = true"
            >升级</a
          >
        </p>
        <div class="copyrightNum">
          图片配额共{{loginInfo.current_team_id && loginInfo.current_team_copyright_image}}张，
          已下载<span>{{loginInfo.current_team_id && loginInfo.current_team_copyright_image && (loginInfo.current_team_copyright_image - loginInfo.current_team_copyright_image_canuse)}}</span>张；
          剩余{{loginInfo.current_team_id && loginInfo.current_team_copyright_image_canuse}}张，
          样图配额共{{loginInfo.current_team_id && loginInfo.current_team_demo_image}}张，
          剩余<span>{{loginInfo.current_team_id && loginInfo.current_team_demo_image_canuse}}</span>张</div>
      </div>
      <div
        class="mi-right"
        v-if="
          (loginInfo.current_team_role === 1 || loginInfo.current_team_role === 2) && !current_team_info.corp_id
        "
      >
        <el-button type="primary" class="invite-btn" @click.stop="inviteHandle"
          >邀请成员</el-button
        >
        <el-dropdown
          trigger="click"
          @command="commandMember"
          @visible-change="visibleChange"
        >
          <el-button type="primary" style="width: 120px">
            添加成员 <i :class="dropdownClass"></i>
          </el-button>
          <el-dropdown-menu slot="dropdown" class="member-drop">
            <el-dropdown-item command="moreAdd">批量添加</el-dropdown-item>
            <el-dropdown-item command="singleAdd">单独添加</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>
    <div class="member-content">
      <div class="mc-title">
        <h4>成员管理</h4>
        <div v-if="!current_team_info.corp_id">
          <el-input
            type="text"
            v-model.trim="keywords"
            placeholder="账号名称或手机号"
            @keyup.enter.native="searchMember(true)"
            class="search-member-input"
          >
            <i
              slot="suffix"
              :class="
                !keywords
                  ? 'el-input__icon el-icon-search'
                  : 'el-input__icon el-icon-close'
              "
              style="cursor: pointer"
              @click.stop="searchMember(false)"
            ></i>
          </el-input>
          <el-button
            v-if="
              (loginInfo.current_team_role === 1 ||
              loginInfo.current_team_role === 2)
            "
            @click="approveShow"
            type="primary"
            style="margin-left: 29px"
          >
            {{ apply_count }}
            待审批成员
          </el-button> 
        </div>
      </div>
      <div class="mc-con">
        <el-table :data="list" v-if="list.length" class="el-table-title--color">
          <el-table-column prop="nick_name" label="" width="100" align="center">
            <template slot-scope="scope">
              <img
                v-if="scope.row.image_url"
                :src="scope.row.image_url"
                width="35"
                height="35"
                class="avator-img"
              />
              <img
                src="@/assets/image/mobile_head.png"
                width="35"
                height="35"
                v-else
                class="avator-img"
              />
            </template>
          </el-table-column>
          <el-table-column prop="nick_name" label="账号名称" width="200">
            <template slot-scope="scope">
              {{ scope.row.nick_name || scope.row.mobile }}
            </template>
          </el-table-column>
          <el-table-column prop="mobile" label="手机号" v-if="!current_team_info.corp_id"> </el-table-column>
          <el-table-column>
            <template slot="header">
              角色
              <p style="display: inline-block">
                <el-popover
                  placement="bottom"
                  popper-class="common-introduce-popover"
                  trigger="click"
                >
                  <div class="common-introduce">
                    <div>角色说明：</div>
                    <div v-if="isEnterprise">
                      管理员：可以创建管理使用企业模板
                    </div>
                    <div v-else>
                      管理员：可以邀请管理成员、创建管理使用企业模板
                    </div>
                    <div>设计师：可以创建管理使用企业模板</div>
                    <div>成员：可以使用企业模板</div>
                  </div>
                  <div slot="reference">
                    <span
                      class="icon-doubt iconfont"
                      style="color: #909399"
                    ></span>
                  </div>
                </el-popover>
              </p>
            </template>
            <template slot-scope="scope">
              <div style="white-space: nowrap">
                <span class="role-name">{{ scope.row.role_name }}</span>
                <el-popover
                  placement="right"
                  width="160"
                  trigger="manual"
                  v-model="scope.row.popverStatus"
                  :ref="'popover-' + scope.$index"
                  popper-class="member-popover"
                >
                  <ul class="role-p">
                    <template v-for="item in roleOpt">
                      <li
                        :key="item.value"
                        v-if="loginInfo.current_team_role <= item.value * 1"
                        :class="scope.row.role == item.value ? 'active' : ''"
                        @click.stop="editRole(scope.row, item, 'table')"
                      >
                        {{ item.name }}
                      </li>
                    </template>
                  </ul>
                  <!--

                    如果权限等于1  任何人都可以修改
                    如果权限等于2  只能修改设计师和成员
                  -->
                  <span
                    slot="reference"
                    v-show=" (loginInfo.current_team_role === 1 && scope.row.id !== uploadType.user_id) || 
                      (loginInfo.current_team_role === 2 &&
                      scope.row.role != 1 &&
                      scope.row.role != 2 &&
                      scope.row.id !== uploadType.user_id)
                    "
                    @click.stop="show(scope.$index, 'table', 'popverStatus')"
                    class="icon-Expand-down iconfont"
                  ></span>
                </el-popover>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="email" :label="!current_team_info.corp_id ? '邮箱' : '部门'" width="240">
            <div slot-scope="scope" v-if="!current_team_info.corp_id">
              <div>{{scope.row.email || '-'}}</div>
              <!-- <div style="white-space: nowrap" v-if="scope.row.email && scope.row.email.length > 1">
                <span>{{ scope.row.email[0].email }}</span>
                <el-popover
                  placement="right"
                  width="220"
                  trigger="manual"
                  v-model="scope.row.popverEmailStatus"
                  popper-class="member-popover"
                >
                  <ul class="role-p">
                    <li
                      v-for="item in scope.row.email" :key="item.id"
                    >
                      {{ item.email }}
                    </li>
                  </ul>
                  
                  <span
                    slot="reference"
                    @click.stop="show(scope.$index, 'table', 'popverEmailStatus')"
                    class="icon-Expand-down iconfont"
                  ></span>
                </el-popover>
              </div>
              <div v-else-if="scope.row.email && scope.row.email.length > 0">
                {{scope.row.email[0].email || '-'}}
              </div> -->
            </div>
            <div slot-scope="scope" v-else>
              {{scope.row.department || '-'}}
            </div>
          </el-table-column>
          <el-table-column prop="copyright_image_num" label="图片剩余下载额度" >
            <template slot-scope="scope">
              {{ scope.row.copyright_image_num || "0" }}
            </template>
          </el-table-column>
          <el-table-column prop="demo_image_num" label="样图剩余下载额度">
            <template slot-scope="scope">
              {{ scope.row.demo_image_num || "0" }}
            </template>
          </el-table-column>
          <el-table-column prop="remarks" label="备注" width="250">
            <template slot-scope="scope">
              <template v-if="scope.row.remarks">
                <el-popover
                  placement="top-start"
                  width="200"
                  trigger="hover"
                  :content="scope.row.remarks || '-'"
                >
                  <p slot="reference" class="text-hidden" style="width: 150px">
                    {{ scope.row.remarks || "-" }}
                  </p>
                </el-popover>
              </template>

              <p class="text-hidden" v-else>{{ scope.row.remarks || "-" }}</p>
            </template>
          </el-table-column>
          <el-table-column
            label="操作"
            width="140"
            v-if="
              loginInfo.current_team_role === 1 ||
              loginInfo.current_team_role === 2"
          >
            <template slot-scope="scope">
              <template>
                <el-button
                  @click.native.prevent="editRow(scope.row)"
                  type="text"
                  size="small"
                  v-if="scope.row.actionStatus"
                >
                  编辑
                </el-button>
                <el-button
                  @click.native.prevent="deleteRow(scope.row)"
                  type="text"
                  size="small"
                  class="danger-text--btn"
                  v-if="
                    scope.row.actionStatus !== 1 && scope.row.actionStatus !== 0 && !current_team_info.corp_id
                  "
                >
                  移出
                </el-button>
              </template>
            </template>
          </el-table-column>
        </el-table>

        <no-content v-if="!list.length" :text="'暂无搜索结果'" />
      </div>
    </div>

    <el-dialog
      :visible.sync="dialogVisible"
      width="448px"
      class="team-dialog"
      :title="addTitle"
      @open="openAddMember"
    >
      <div class="dialog-body">
        <!-- <div class="dialog-title">
          <h4>设置成员</h4>
        </div> -->
        <el-form
          :model="ruleForm"
          :rules="rules"
          ref="addRuleForm"
          label-width="100px"
          class="demo-ruleForm"
        >
          <el-form-item label="手机号" prop="mobile" v-if="!ruleForm.id">
            <el-input
              v-model.trim="ruleForm.mobile"
              maxlength="11"
              placeholder="请输入手机号"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="角色"
            prop="role"
            v-if="
              !ruleForm.id ||
              (loginInfo.current_team_role === 1 &&
                (ruleForm.actionStatus == 2 || ruleForm.actionStatus == 3)) ||
              (loginInfo.current_team_role === 2 && ruleForm.actionStatus == 3)
            "
          >
            <!--
              权限不等于1  并且权限等于2
          -->
            <el-select v-model="ruleForm.role" placeholder="请选择角色">
              <template v-for="item in roleOpt">
                <el-option
                  v-if="loginInfo.current_team_role <= item.value * 1 && item.value != 1"
                  :key="item.value"
                  :label="item.name"
                  :value="item.value"
                ></el-option>
              </template>
            </el-select>
          </el-form-item>
          <el-form-item label="邮箱" prop="email" v-if="!current_team_info.corp_id && !ruleForm.id">
            <el-input
              v-model.trim="ruleForm.email"
              placeholder="请输入邮箱"
              maxlength="100"
            ></el-input>
          </el-form-item>
          <el-form-item label="图片下载额度" prop="copyright_num" v-if="ruleForm.id && loginInfo.current_team_role === 1 && ruleForm.role != 1">
            <el-input
              v-model.number="ruleForm.copyright_num"
              placeholder="请输入数字"
            ></el-input>
          </el-form-item>
          <el-form-item label="样图下载额度" prop="demo_num" v-if="ruleForm.id && loginInfo.current_team_role === 1 && ruleForm.role != 1">
            <el-input
              v-model.number="ruleForm.demo_num"
              placeholder="请输入数字"
            ></el-input>
          </el-form-item>
          <el-form-item label="部门" prop="department" v-if="current_team_info.corp_id">
            <el-input
              v-model="ruleForm.department"
              placeholder="请输入部门"
            ></el-input>
          </el-form-item>
          <el-form-item label="备注" prop="remarks">
            <el-input
              v-model.trim="ruleForm.remarks"
              type="textarea"
              placeholder="请输入备注"
            ></el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button
          class="confirm-btn"
          type="primary"
          @click.stop="submitAddMember"
        >
          保存
        </el-button>
      </span>
    </el-dialog>

    <el-dialog
      :visible.sync="moreDialogVisible"
      width="510px"
      class="team-dialog more-member-dialog"
      title="批量导入成员"
      @close="uploadClose"
    >
      <div class="dialog-body">
        <!-- <div class="dialog-title">
          <h4>批量导入成员</h4>
        </div> -->
        <div class="member-dialog-con">
          <div class="member-first">
            <p>1、下载导入模板</p>
            <el-button
              class="download-member"
              type="primary"
              @click.stop="downloadExcel"
            >
              下载模板<i class="iconfont icon-weibiaoti-1-05"></i>
            </el-button>
            <p>
              手机号、邮箱为必填项，导入数量请控制在500条内，角色名称仅支持：管理员、设计师、成员
            </p>
          </div>
          <div class="member-two">
            <div class="mt-title">
              <p>2、上传文件</p>
              <el-popover placement="right" width="250" trigger="hover">
                <div class="info-upload">
                  <dl>
                    <dt>说明</dt>
                    <dd>数据未正常导入的原因：</dd>
                    <dd>手机号重复</dd>
                    <dd>邮箱账号重复</dd>
                    <dd>角色名称错误</dd>
                  </dl>
                </div>
                <i class="iconfont icon-doubt" slot="reference"></i>
              </el-popover>
            </div>

            <div class="member-upload" v-loading="uploading">
              <el-upload
                v-if="!uploadSuccessInfo"
                class="start-m-up"
                :show-file-list="false"
                :http-request="addAllMember"
              >
                <div>
                  <div
                    style="
                      display: flex;
                      align-items: center;
                      flex-direction: column;
                    "
                  >
                    <!-- <el-button
                      size="small"
                      type="primary"
                      class="start-member-btn"
                      >点击上传<i class="el-icon-upload el-icon--right"></i
                    ></el-button> -->
                    <el-button class="upload-member" type="primary">
                      点击上传
                      <i class="iconfont icon-weibiaoti-1-06"></i>
                    </el-button>
                    <div slot="tip" class="el-upload__tip">
                      仅支持 .xls .xlsx 类型文件
                    </div>
                  </div>
                </div>
              </el-upload>
              <div v-else class="upload-after">
                <div v-if="uploadInfo.status === 1" class="ua-success">
                  <p class="ua-top-text">
                    <i class="el-icon-circle-check"></i>导入成功
                  </p>
                  <p class="ua-msg">共导入 {{ uploadInfo.msg }} 名成员</p>
                </div>
                <div v-else class="ua-error">
                  <p class="ua-top-text">
                    <i class="el-icon-circle-close"></i>导入失败
                  </p>
                  <p class="ua-msg">{{ uploadInfo.error }}</p>
                </div>
                <div class="next-btn">
                  <el-upload
                    :http-request="addAllMember"
                    :show-file-list="false"
                  >
                    <button class="cancel-btn">继续导入</button>
                  </el-upload>
                  <button class="confirm-btn" @click.stop="uploadClose">
                    完成
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </el-dialog>

    <el-dialog
      :visible.sync="inviteVisible"
      width="528px"
      title="邀请成员"
      @close="inviteClose"
      class="invite-dialog"
    >
      <ul class="invite-tabs">
        <li
          :class="!inviteToggleStatus ? 'invite-tab-active' : ''"
          @click="inviteURL"
        >
          发送邀请链接
        </li>
        <!-- <li
          :class="inviteToggleStatus ? 'invite-tab-active' : ''"
          @click="inviteCode"
        >
          微信扫码邀请
        </li> -->
      </ul>

      <div v-if="!inviteToggleStatus">
        <div class="invite-input">
          {{ inviteHref }}
        </div>
        <p class="invite-wx-text">邀请链接有效期24小时</p>
        <p class="invite-wx-text">邀请成员需审批通过后才可正式加入团队</p>
        <el-button
          type="primary"
          class="invite-dialog-btn"
          @click="copyURL"
          :style="copyStatus ? { background: 'rgb(42, 177, 57)' } : {}"
        >
          复制链接
        </el-button>
      </div>
      <div v-else>
        <img :src="inviteWechat" alt="" class="min-code-img" />
        <p class="invite-mini" style="">邀请成员需审批通过后才可正式加入团队</p>
      </div>
    </el-dialog>
    <remove-dialog :title="'是否确认删除该成员'" @remove="remove" v-if="removeDialogStatus"/>
    <!--过期弹出框-->
    <expireTeamDialog />

    <el-dialog
      title="待审批成员"
      class="approve-dialog"
      :visible.sync="approveStatus"
      width="600px"
    >
      <div class="approve__body">
        <el-table :data="approveInfo" height="299px">
          <el-table-column width="30">
            <template slot-scope="scope">
              <el-checkbox-group
                v-model="checkedMember"
                @change="handleCheckedMembersChange"
              >
                <el-checkbox
                  :disabled="scope.row.status !== 1"
                  :label="scope.row"
                  :key="scope.row.id"
                  style="width:0;"
                ></el-checkbox>
              </el-checkbox-group> 
            </template>
          </el-table-column>
          <el-table-column width="50">
            <template slot-scope="scope">
              <img
                class="head-photo"
                :src="scope.row.image_url || img"
                width="35"
                height="35"
              />
            </template>
          </el-table-column>
          <el-table-column prop="nick_name" label="姓名" width="193">
          </el-table-column>
          <el-table-column label="角色">
            <template slot-scope="scope">
              <span class="role-name">{{ scope.row.role_name }}</span>
              <el-popover
                placement="right"
                width="160"
                trigger="manual"
                v-model="scope.row.popverStatus"
              >
                <ul class="role-p">
                  <template v-for="item in roleOpt">
                    <li
                      v-if="loginInfo.current_team_role <= item.value * 1 && item.value != 1"
                      :key="item.value"
                      :class="scope.row.role == item.value ? 'active' : ''"
                      @click.stop="editRole(scope.row, item, 'dialog')"
                    >
                      {{ item.name }}
                    </li>
                  </template>
                </ul>
                <!--

                  如果权限等于1  任何人都可以修改
                  如果权限等于2  只能修改设计师和成员
                -->
                <span
                  slot="reference"
                  v-if="
                    loginInfo.current_team_role === 1 &&
                    scope.row.id !== uploadType.user_id
                  "
                  @click.stop="show(scope.$index, 'dialog')"
                  class="icon-Expand-down iconfont"
                ></span>
                <span
                  slot="reference"
                  v-else-if="
                    loginInfo.current_team_role === 2 &&
                    scope.row.role != 1 &&
                    scope.row.role != 2 &&
                    scope.row.id !== uploadType.user_id
                  "
                  @click.stop="show(scope.$index, 'dialog')"
                  class="icon-Expand-down iconfont"
                ></span>
              </el-popover>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="148">
            <template slot-scope="scope">
              <div class="approvebtn-wrap" v-if="scope.row.status == 1">
                <el-button
                  class="el-button-text--small el-button-text--primary"
                  @click="handleApprove(scope.row, 'agree')"
                >
                  同意
                </el-button>
                <el-button
                  class="el-button-text--small el-button-text--danger"
                  @click="handleApprove(scope.row, 'deny')"
                >
                  拒绝
                </el-button>
              </div>
              <p class="approve-text" v-else-if="scope.row.user_status == 2">
                已同意
              </p>
              <p class="approve-text" v-else>已拒绝</p>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="table-footer">
        <el-checkbox v-model="allCheck" @change="handleCheckAllChange"
          >全选</el-checkbox
        >
        <div class="approvebtn-wrap">
          <!--class="agree-btn approve-btn"-->
          <el-button
            class="el-button-text el-button-text--primary"
            @click="batchApprove('agree')"
          >
            同意
          </el-button>
          <!-- class="refuse-btn approve-btn" -->
          <el-button
            class="el-button-text el-button-text--danger"
            @click="batchRefuse()"
          >
            拒绝
          </el-button>
        </div>
      </div>
    </el-dialog>

    <el-dialog
      class="refuse-confirm-dialog dialog-364"
      :title="`是否确认拒绝${handleMemberInfo ? refusedName : '选中'}的申请？`"
      :visible.sync="refuseConfirmVisible"
      width="364"
    >
      <div class="btn-wrap">
        <el-button @click="refuseConfirmVisible = false"> 取消 </el-button>
        <el-button type="danger" @click="refuseConfirm">拒绝</el-button>
      </div>
    </el-dialog>
    <el-dialog
      class="move-founder-dialog"
      :visible.sync="moveFounderConfirmVisible"
      width="500"
    >
      <div class="move-founder">
        <p> 确定选择 <span>{{moveFounderConfirmName}}</span> 为新的创建者？</p>
        <div>确认转移后你将自弃创建者的身份，同时你的<span>图片下载额度</span>、<span>样图下载额度</span>、<span>授权记录</span>也会转移到新的创建者身上。</div>
      </div>
      <div class="btn-wrap">
        <el-button @click="moveFounderConfirmVisible = false"> 取消 </el-button>
        <el-button type="primary" @click="moveFounderConfirm">确认</el-button>
      </div>
    </el-dialog>

    <el-dialog
      :visible.sync="levelDialogStatus"
      title="升级后获取更多团队成员名额"
      class="level-dialog"
      width="525px"
    >
      <img
        src="../../../../assets/image/contact-us20220620.png"
        alt=""
        class="wx-img"
      />
      <p class="upgrade-text">微信扫码联系客服获得升级</p>
    </el-dialog>

    <rename-dialog ref="renameDialog" @submit="submitRename" v-if="renameStatus"/>
  </div>
</template>

<script>
import { Member } from "@/config/axios/new_api";
import noContent from "@/components/common/noContent.vue";
import renameDialog from "@/components/dialog/renameDialog.vue";
import RemoveDialog from "../../../../components/dialog/removeDialog.vue";
import M from "minimatch";
const img = require("@/assets/image/mobile_head.png");
export default {
  components: { noContent, RemoveDialog, renameDialog },
  data() {
    var checkaccount = (rule, value, callback) => {
        if(this.ruleForm.mobile=='' && this.ruleForm.email==''){
            callback(new Error('请输入邮箱或手机号码 必填一项!'));
        }
        else{
            callback();
        }
    };
    let checkPhone = (rule, value, callback) => {
      let reg = /^1\d{10}$/;
      if (!reg.test(value)) {
        callback(new Error("请输入11位手机号"));
      } else {
        callback();
      }
    };
    let checkEmail = (rule, value, callback) => {
      // const mailReg = /^([a-zA-Z0-9_-\.])+@([a-zA-Z0-9_-])+(.[a-zA-Z0-9_-])+/;
      if (!value) {
        return callback();
      }
      setTimeout(() => {
        if (this.staticFunc.emailRegExp().test(value)) {
          if (value.length > 70) {
            callback(new Error("邮箱长度不能大于70个字符"));
          } else {
            callback();
          }
        } else {
          callback(new Error("请输入正确的邮箱格式"));
        }
      }, 100);
    };
    let checkRemark = (rule, value, callback) => {
      if (value.length > 255) {
        callback(new Error("备注长度不能大于255个字符"));
      } else {
        callback();
      }
    };
    let checkNum = (rule, value, callback) => {
      
      if(value == undefined || value == '' || /^[0-9]+.?[0-9]*/.test(value)) {
        callback()
      }else {
        callback(new Error("请输入数字"));
      }
    };
    let checkDepartmentName = (rule, value, callback) => {
      if (value.length > 20) {
        callback(new Error("部门长度不能大于20个字符"));
      } else if(value.length < 2 && value.length > 0 ){
        callback(new Error("部门长度不能小于2个字符"));
      } else {
        callback();
      }
    };
    return {
      img,
      list: [{}],
      dialogVisible: false,
      moreDialogVisible: false,
      inviteVisible: false,
      copyStatus: false,
      inviteToggleStatus: false,
      removeDialogStatus: false,
      uploading: false,
      uploadSuccessInfo: false,
      rolePopver: false,
      approveStatus: false,
      checkedMember: [], // 待审批成员选择
      approveInfo: [], // 查询待审批人员列表
      allCheck: false,
      refusedName: "",
      refuseConfirmVisible: false,
      moveFounderConfirmVisible: false,   //转移创建者弹窗
      levelDialogStatus: false,
      renameStatus: false,
      addTitle: "新增成员",
      keywords: "",
      dropdownClass: "el-icon-arrow-down",
      roleOpt: [
        { name: "创建者", value: "1" },
        { name: "管理员", value: "2" },
        { name: "设计师", value: "3" },
        { name: "成员", value: "4" },
      ],
      ruleForm: {
        mobile: "",
        nick_name: "",
        role: "4",
        email: "",
        remarks: "",
        copyright_num: 0,
        demo_num: 0,
        department: "",
      },
      rules: {
        mobile: [
           { validator:checkaccount },
        ],
        role: [{ required: true, message: "请选择角色", trigger: "blur" }],
        nick_name: [
          { required: true, message: "请输入账号名称", trigger: "blur" },
        ],
        email: [
           { validator:checkaccount },
        ],
        remarks: [{ validator: checkRemark, trigger: "blur" }],
        copyright_num: [{type: "number", message: "请输入数字",validator: checkNum, trigger: 'blur'}],
        demo_num: [{type: "number",message: "请输入数字",validator: checkNum, trigger: 'blur'}],
        department:[{ type: "string", validator: checkDepartmentName, trigger: 'blur'}]
      },
      manageInfo: {},
      inviteHref: "",
      inviteWechat: "",
      renameInput: "", // 重命名名称
      removeObj: {}, // 删除成员信息
      uploadInfo: null,
      apply_count: 0,   //待审批人数
      current_team_info: {}, // 当前团队信息
    };
  },
  computed: {
    loginInfo() {
      return this.$store.getters.loginInfo;
    },
    uploadType() {
      return {
        user_id: this.loginInfo.id,
        team_id: this.loginInfo.current_team_id,
      };
    },
  },
  created() {
    this.keywords = "";
    this.getData();
  },
  methods: {
    visibleChange(val) {
      this.dropdownClass = val ? "el-icon-arrow-up" : "el-icon-arrow-down";
    },
    renameOpen() {
      this.renameStatus = true;
      this.$nextTick(() => {
        this.renameInput = this.loginInfo.current_team_name;
      });
    },
    submitRename() {
      let submitData = {
        rename: this.$refs.renameDialog.renameObj.renameInput,
        team_id: this.loginInfo.current_team_id,
      };
      Member.rename(submitData).then((res) => {
        if (res.status === 1) {
          this.renameStatus = false;
          this.$store.dispatch("loginInfo")
        }
      });
    },
    //  判断是否要全选----------------------------------------------
    handleCheckAllChange(val) {
      this.checkedMember = val ? this.approveInfo : [];
    },
    //  判断是否要全选----------------------------------------------
    handleCheckedMembersChange(value) {
      let checkedCount = value.length;
      // 计算出尚未审批的成员的数量,也就是 this.approveInfoLength
      let approveInfoLength = this.approveInfo.length;
      this.allCheck = checkedCount === approveInfoLength;
    },
    // 点击同意或拒绝的按钮---------------------------------------
    handleApprove(approvingMemberInfo, audit) {
      if (audit == "deny") {
        // 如果点击的是拒绝，进行二次确认
        this.refuseConfirmVisible = true;
        this.refusedName = approvingMemberInfo.nick_name;
        // 如果点拒绝，触发refuseConfirm方法，需要把当前操作成员的信息传递过去
        this.handleMemberInfo = approvingMemberInfo;
      } else {
        // 同意，直接走团队审批成员的接口
        this.toApproveMember(approvingMemberInfo, "agree");
      }
      // 调用团队审批的接口
      // var response = this.requestArrove(approvingMemberInfo, audit)
    },
    // 点击批量审批的同意和拒绝时--------------------------------
    batchApprove(audit) {
      if (this.checkedMember.length === 0) {
        // 如果没有选择任何成员，点同意拒绝没有任何反应
        return;
      }
      if (
        this.checkedMember.length > this.surplusMemberNumber &&
        audit === "agree"
      ) {
        this.batchRefuseConfirmVisible = false;
        // 若超过名额上线，提示升级弹窗(不可同意，可拒绝)
        this.upgradeVisible = true;
      } else {
        // 走团队审批的接口
        this.toApproveMember(this.checkedMember, audit);
      }
    },
    // 点批量拒绝时
    batchRefuse() {
      if (this.checkedMember.length === 0) {
        // 如果没有选择任何成员，点同意拒绝没有任何反应
        return;
      }
      this.handleMemberInfo = '';
      this.refuseConfirmVisible = true;
    },
    // 确认拒绝某人的申请-------------------------------------------------
    refuseConfirm() {
      // 走团队审批成员的接口
      if(this.handleMemberInfo) {
        this.toApproveMember(this.handleMemberInfo, "deny");
      }else {
        this.toApproveMember(this.checkedMember, "deny");
      }
    },
    // 转移创建者
    moveFounderConfirm() {
      var requestParams = {
        team_id: this.loginInfo.current_team_id,
        role: 1,
        role_user_id: this.moveFounderConfirmUserId,
      };
      Member.move_founder(requestParams).then((res) => {
        if (res.status === 1) {
          location.reload();
        }
      });
    },
    // 团队成员审批的接口------------------------------------------
    toApproveMember(handlingMemberInfo, audit) {
      // 将要进行审批人员的信息放入数组中
      var handlingMemberArr = [];
      if (Array.isArray(handlingMemberInfo)) {
        // 如果是数组
        handlingMemberArr = handlingMemberInfo;
      } else {
        handlingMemberArr.push(handlingMemberInfo);
      }
      var memberObj = {};
      handlingMemberArr.forEach((item) => {
        memberObj[item.id] = item.role;
      });
      var requestParams = {
        team_id: this.loginInfo.current_team_id,
        audit: audit,
        members: memberObj,
      };
      Member.audit(requestParams).then((res) => {
        if (res.status === 1) {
          this.refuseConfirmVisible = false;
          this.batchRefuseConfirmVisible = false;
          //  更新待审批成员的列表
          this.approveShow();
          this.getData();
          this.getApplyCount();
          // 被选中的成员列表改为空
          this.checkedMember = [];
          // 全选不被选中
          this.allCheck = false;
        }
        this.refuseConfirmVisible = false;
        this.batchRefuseConfirmVisible = false;
        this.approveStatus = false;
      });
    },
    approveShow() {
      this.approveStatus = true;
      Member.applies({
        team_id: this.loginInfo.current_team_id,
      }).then((res) => {
        if(res.data) {
          this.approveInfo = res.data.map((item) => {
            item = Object.assign(item, item.user);
            item.role = 4;
            item.role_name = "成员";
            item.popverStatus = false;
            return item;
          });
        }else{
          this.approveInfo = [];
        }
      });
    },
    inviteHandle() {
      let res = this.expireHandle();
      if (res) {
        this.inviteURL()
      }
    },
    getData() {
      Member.memberList({
        team_id: this.loginInfo.current_team_id,
        keyword: this.keywords
      }).then((res) => {
        if (res.status === 1) { 
          if(!res.data) {
            this.list = [];
            return ;
          }
          this.list = res.data.map((item) => {
            item.popverStatus = false;
            item.popverEmailStatus = false;
            // 如果权限等于 = 1 直接返回 不允许更改创建者
            // 如果权限 = 2 并且
            let status = 0;
            // 如果权限等于 = 1 直接返回 不允许更改创建者
            if (this.loginInfo.current_team_role === 1) {
              status = 1;
              if ([2, 3, 4].includes(item.role)) {
                status = 2;
              }
            } else if (
              this.loginInfo.current_team_role === 2 &&
              (item.role == 3 || item.role == 4)
            ) {
              status = 3;
            }
            item.actionStatus = status;
            return item;
          });
        }
      });
      this.getApplyCount();
    },
    downloadExcel(e) {
      this.buttonBlur(e);
      window.open('https://respool.isheji.com/isheji/static/pc/isheji_importTemplate.xlsx')
      return 
      Member.download_excel().then((res) => {
        let name = "爱设计成员导入模板.xlsx";
        if (window.navigator.msSaveOrOpenBlob) {
          // 兼容ie11
          var blobObject = new Blob([res]);
          window.navigator.msSaveOrOpenBlob(blobObject, name);
        } else {
          let url = URL.createObjectURL(new Blob([res]));
          let a = document.createElement("a");
          document.body.appendChild(a);
          a.href = url;
          a.download = name;
          a.target = "_blank";
          a.click();
          a.remove();
        }
      });
    },
    copyURL() {
      var oInput = document.createElement("input");
      oInput.value = this.inviteHref;
      document.body.appendChild(oInput);
      oInput.select(); // 选择对象
      document.execCommand("Copy"); // 执行浏览器复制命令
      document.body.removeChild(oInput);
      this.copyStatus = true;
    },
    commandMember(command) {
      let res = this.expireHandle();
      if (res) {
        if (command === "singleAdd") {
          this.dialogVisible = true;
          this.addTitle = "新增成员";
          this.ruleForm = {
            mobile: "",
            nick_name: "",
            role: "4",
            email: "",
            remarks: "",
          };
        } else {
          this.moreDialogVisible = true;
        }
      }
    },
    searchMember(status) {
      if (!status) {
        this.keywords = "";
      }
      this.getData();
    },
    inviteURL() {
      this.inviteToggleStatus = false;
      Member.invitation({ team_id: this.loginInfo.current_team_id }).then(
        (res) => {
          if (res.status === 1) {
            this.inviteVisible = true;
            this.inviteHref = res.data.invitation_url;
          }else{
            this.inviteHref = '';
          }
        }
      );
    },
    inviteCode() {
      this.inviteToggleStatus = true;
      Member.qrcode({ team_id: this.loginInfo.current_team_id }).then((res) => {
        if (res.status === 1) {
          this.inviteWechat = res.data.url;
        }
      });
    },
    addAllMember(params) {
      let res = this.expireHandle();
      if (res) {
        this.uploading = true;
        let file = params.file;
        var dotIndex = file.name.lastIndexOf(".") + 1;
        var fileTypeStr = file.name.slice(dotIndex);
        let img = ["xlsx", "xls"];
        if (!img.includes(fileTypeStr)) {
          this.$message({
            message: "请上传xlsx文件",
            center: true,
            customClass: "handle-success",
          });
          this.uploading = false;
          return;
        }
        let form = new FormData();
        form.append("file", file);
        form.append("team_id", this.loginInfo.current_team_id);
        Member.add_excel_member(form).then((res) => {
          this.uploading = false;
          this.uploadSuccessInfo = true;
          this.uploadInfo = res;
          if (res.status === 1) {
            this.uploadInfo.msg = res.data.num;
            this.getData();
          }
        });
      }
    },
    inviteOpen() {
      this.inviteURL();
    },
    openAddMember() {
      this.$nextTick(() => {
        this.$refs.addRuleForm.resetFields();
        if (this.addTitle === "新增成员") {
          this.ruleForm = {
            mobile: "",
            nick_name: "",
            role: "4",
            email: "",
            remarks: "",
          };
        }
      });
    },
    inviteClose() {},
    editRow(row) {
      this.dialogVisible = true;
      this.addTitle = "编辑成员";
      this.ruleForm = {};
      let data = {
        id: row.id,
        nick_name: row.nick_name,
        mobile: row.mobile,
        remarks: row.remarks || "",
        actionStatus: row.actionStatus,
        role: row.role == 1 ? row.role : "",
      };
      if(this.current_team_info.corp_id){
        data.department = row.department || ""
      }
      if(this.loginInfo.current_team_role == 1) {
        data.copyright_num = row.copyright_image_num;
        data.demo_num = row.demo_image_num;
      }
      // 在此for循环主要在可以单独更改角色，获取的属性有误, 导致编辑框只展示数字

      for (let i = 0; i < this.roleOpt.length; i++) {
        if (row.role == this.roleOpt[i].value) {
          if (typeof this.roleOpt[i].value === "string") {
            data.role = row.role + "";
          } else {
            data.role = Number(row.role);
          }
        }
      }
      this.$nextTick(() => {
        this.ruleForm = Object.assign({}, data);
      });
    },
    deleteRow(row) {
      this.removeDialogStatus = true;
      this.removeObj = row;
    },
    remove() {
      // 删除成员
      let team_id = this.loginInfo.current_team_id;
      let remove_user_id = this.removeObj.id;
      Member.remove({ team_id, remove_user_id }).then((res) => {
        if (res.status === 1) {
          this.removeDialogStatus = false;
          this.$message.success("删除成功");
          this.getData();
        }
      });
    },
    show(index, type, params) {
      if (type === "table") {
        for (let i = 0; i < this.list.length; i++) {
          if (i !== index) {
            this.list[i][params] = false;
          }
        }
        let obj = Object.assign({}, this.list[index]);
        obj[params] = !obj[params];
        this.$set(this.list, index, obj);
      } else {
        for (let i = 0; i < this.approveInfo.length; i++) {
          if (i !== index) {
            this.approveInfo[i].popverStatus = false;
          }
        }
        let obj = Object.assign({}, this.approveInfo[index]);
        obj.popverStatus = !obj.popverStatus;
        this.$set(this.approveInfo, index, obj);
      }
    },
    closePopver() {
      for (let i = 0; i < this.list.length; i++) {
        this.list[i].popverStatus = false;
        this.list[i].popverEmailStatus = false;
      }
      for (let i = 0; i < this.approveInfo.length; i++) {
        this.approveInfo[i].popverStatus = false;
      }
    },

    editRole(row, role, type) {
      if (row.role === role.value) return;
      let id = this.loginInfo.current_team_id;
      // let submitData = Object.assign({}, row);
      role.value = role.value * 1;
      if (type === "table") {
        if(role.value == 1) {
          this.moveFounderConfirmName = row.nick_name;
          this.moveFounderConfirmUserId = row.id;
          this.moveFounderConfirmVisible = true;
        }else {
          Member.edit_role(
            { team_id: id, role_user_id: row.id, role: role.value }
          ).then((res) => {
            if (res.status === 1) {
              this.dialogVisible = false;
              this.getData();
            }
          });
        }
        
      } else {
        let newRow = {};
        let index;
        for (let i = 0; i < this.approveInfo.length; i++) {
          if (this.approveInfo[i].user_id === row.user_id) {
            this.approveInfo[i].role = role.value;
            this.approveInfo[i].role_name = role.name;
            index = i;
            newRow = this.approveInfo[i];
          }
        }
        this.$set(this.approveInfo, index, newRow);
      }
    },
    editEmail(index, item) {
      let obj = Object.assign({}, this.list[index]);
      obj.popverEmailStatus = false;
      this.$set(this.list, index, obj);
    },
    submitAddMember(e) {
      this.buttonBlur(e);
      // 新增编辑成员
      this.$refs["addRuleForm"].validate((valid) => {
        if (valid) {
          if (this.addTitle === "新增成员") {
            let submitData = Object.assign({}, this.ruleForm);
            submitData.role = submitData.role * 1;
            Member.add_team_member({
              ...submitData,
              team_id: this.loginInfo.current_team_id,
            }).then((res) => {
              if (res.status === 1) {
                this.dialogVisible = false;
                this.getData();
              }
            });
          } else {
            let submitData = Object.assign({}, this.ruleForm);
            submitData.role = submitData.role * 1;
            if(submitData.copyright_num || submitData.copyright_num == 0) {
              submitData.copyright_num = submitData.copyright_num * 1;
            }else {
              delete submitData.copyright_num
            }
            if(submitData.demo_num || submitData.demo_num == 0) {
              submitData.demo_num = submitData.demo_num * 1;
            }else {
              delete submitData.demo_num
            }
            Member.edit_team_member({
              ...submitData,
              team_id: this.loginInfo.current_team_id,
            }).then((res) => {
              if (res.status === 1) {
                this.dialogVisible = false;
                this.getData();
              }
            });
          }
        } else {
          return false;
        }
      });
    },
    uploadClose() {
      this.uploadSuccessInfo = false;
      this.moreDialogVisible = false;
      this.uploading = false;
      this.uploadInfo = null;
    },

    getApplyCount() {
      Member.getCurrentTeam().then(res => {
        if(res.status == 1) {
          this.apply_count = res.data.apply_nums;
          this.current_team_info = res.data
        } 
      })
    }
  },
};
</script>

<style lang="scss" scoped>
.member {
  ::v-deep( .el-table),
  ::v-deep( .el-table__body-wrapper) {
    overflow: inherit;
    overflow-y: auto;
  }
  ::v-deep( .el-button--small) {
    padding: 0;
  }
  min-height: calc(100vh - 60px);
  .member-info {
    margin: 15px 0;
    padding: 0 36px;
    width: 100%;
    height: 170px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    background: url("../../../../assets/image/message_bg.png") no-repeat center;
  }
  .member-content {
    padding: 9px 0 0 0;
  }
  .invite-btn {
    margin-right: 30px;
  }
  .mi-left {
    color: #3c3c43;
    .mil-title {
      display: flex;
      img {
        width: 40px;
        height: 40px;
        margin-left: 30px;
        cursor: pointer;
      }
    }
    .team-upgrade {
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: $activeColor;
      margin-left: 16px;
    }
    h3 {
      font-size: 25px;
      line-height: 36px;
      max-width: 350px;
    }
    p {
      margin-top: 8px;
      line-height: 20px;
      font-size: 14px;
    }
    .copyrightNum {
      font-size: 12px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #333333;
      line-height: 20px;
      margin-top: 15px;
      span {
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        font-size: 16px;
      }
    }
  }
  .mc-title {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-right: 36px;
    h4 {
      color: #2d2d32;
      line-height: 20px;
      font-size: 13px;
    }
  }
  .mc-con {
    margin-top: 23px;
  }

  .invite-tabs {
    width: 100%;
    padding: 0 50px;
    box-sizing: border-box;
    text-align: center;
    display: flex;
    li {
      width: 213px;
      height: 40px;
      background: #f3f3f3;
      border-radius: 0px 8px 8px 0px;
      line-height: 40px;
      font-size: 14px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #3c3c43;
      cursor: pointer;
      &:first-of-type {
        border-radius: 8px;
      }
    }
    .invite-tab-active {
      width: 100%;
      background: linear-gradient(180deg, #646470 0%, #3c3c4b 100%);
      color: #fff;
    }
  }
  .invite-input {
    width: 427px;
    height: 40px;
    background: #fff;
    border-radius: 8px;
    border: 1px solid #aaaab1;
    padding-left: 8px;
    line-height: 38px;
    box-sizing: border-box;
    margin: 24px 0 24px 50px;
  }
  .invite-wx-text {
    font-size: 13px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #3c3c43;
    line-height: 20px;
    padding-left: 58px;
    width: 100%;
    box-sizing: border-box;
  }
  .invite-dialog-btn {
    width: 110px;
    height: 40px;
    padding: 0;
    text-align: center;
    line-height: 40px;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #fff;
    margin: 48px 0 0 208px;
  }
  .min-code-img {
    margin: 34px 0 34px 203px;
    width: 120px;
    height: 120px;
  }
  .invite-mini {
    text-align: center;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #3c3c43;
    line-height: 18px;
  }
  .upload-after {
    text-align: center;
    padding-top: 30px;
    .el-icon-circle-check {
      color: $activeColor;
      font-size: 25px;
      margin-right: 5px;
    }
    .el-icon-circle-close {
      color: rgb(186, 106, 84);
      font-size: 25px;
      margin-right: 5px;
    }
    .ua-top-text {
      font-size: 14px;
      font-weight: 400;
      color: #3c3c43;
      line-height: 25px;
      display: flex;
      justify-content: center;
      align-items: center;
      margin-bottom: 8px;
    }
    .ua-msg {
      margin-bottom: 8px;
      color: #999;
    }
    .next-btn {
      display: flex;
      justify-content: center;
      align-items: center;
    }
    .cancel-btn {
      margin-right: 48px;
    }
  }
}
.approve-dialog {
  .icon-Expand-down {
    font-size: 16px;
    position: relative;
    top: 2px;
    cursor: pointer;
  }
  ::v-deep(.el-dialog__body) {
    padding: 0;
  }
  ::v-deep( .el-dialog__header) {
    height: 76px;
  }
  .approve__body {
    padding: 0 12px;
  }
  ::v-deep(.el-table::before) {
    height: 0;
  }
  ::v-deep(.cell) {
    color: #3c3c43;
  }
  .approve__body {
    ::v-deep( .el-checkbox__input.is-checked + .el-checkbox__label) {
      display: none;
    }
  }

  .table-footer {
    border-top: 1px solid #e1e1e1;
    height: 65px;
    line-height: 65px;
    padding: 0 24px;
    display: flex;
    justify-content: space-between;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #3c3c43;
  }
  .approvebtn-wrap {
    display: flex;
    align-items: center;
    .approve-btn {
      display: block;
      width: 70px;
      height: 28px;
      border-radius: 6px;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      text-align: center;
      line-height: 26px;
      box-sizing: border-box;
      background-color: #fff;
    }
    .agree-btn {
      border: 1px solid #5a2df5;
      color: #5a2df5;
      margin-right: 8px;
    }
    .refuse-btn {
      color: #ff6464;
      border: 1px solid #ff6464;
    }
  }
}
.refuse-confirm-dialog {
  ::v-deep( .el-dialog) {
    height: 264px;
    width: 364px;
    ::v-deep( .el-dialog__body) {
      padding: 0px 50px;
    }
  }
  ::v-deep( .el-dialog__header) {
    padding: 88px 0 0 0;
    height: 156px;
  }
  .btn-wrap {
    width: 100%;
    display: flex;
    padding: 0;
    box-sizing: border-box;
    justify-content: space-between;
  }
}
.move-founder-dialog {
  border-radius: 8px;
  ::v-deep( .el-dialog) {
    width: 500px;
    height: 234px;
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    margin: auto!important;
    .el-dialog__body {
      padding: 0px 37px;
    }
  }
  .move-founder {
    padding-top: 11px;
    margin-bottom: 34px;
    p {
      font-size: 18px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #3C3C43;
      line-height: 20px;
      display: flex;
      span {
          color: #5a2df5;
          max-width: 9em;
          display: inline-block;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          margin: 0 5px;
      }
    }
    div {
      margin-top: 15px;
      font-size: 16px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #3C3C43;
      line-height: 20px;
      span {
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
      }
    }
    
    
  }
  .btn-wrap {
    button {
      width: 170px;
      height: 46px;
    }
  }
}
.level-dialog {
  .wx-img {
    width: 164px;
    height: 164px;
    background: #aaaab1;
    margin: 24px auto 48px;
  }
  ::v-deep( .el-dialog__header) {
    height: 84px;
  }
  ::v-deep( .el-dialog) {
    height: 388px;
    font-weight: 400;
    color: #3c3c43;
    line-height: 20px;
    text-align: center;
  }
}
</style>
<style lang="scss">
.invite-dialog {
  .el-dialog {
    height: 388px;
  }
  .el-dialog__body {
    padding: 0;
  }
  .el-dialog__header {
    padding: 40px 0 0 0;
    width: 100%;
    height: 84px;
    box-sizing: border-box;
    text-align: center;
  }
}
.mc-title {
  .el-input,
  .el-input--small .el-input__inner {
    width: 220px;
    height: 40px;
    border-right: 0;
  }
  i {
    cursor: pointer;
    &:hover {
      color: #999;
    }
  }
}
.team-dialog {
  .el-dialog {
    border-radius: 12px;
  }
  .el-dialog__body {
    padding: 40px 40px 0;
    .el-select {
      width: 268px;
    }
  }
  .el-dialog__headerbtn .el-dialog__close {
    font-size: 21px;
  }
}
.more-member-dialog {
  .el-dialog {
    height: 517px;
  }
  .el-dialog__body {
    padding: 40px 44px 0 48px;
  }
}
.more-member-dialog {
  .download-member {
    margin: 12px 0;
    display: flex;
    align-items: center;
    justify-content: center;
    .iconfont {
      color: #fff;
      margin-left: 5px;
    }
  }
  .upload-member {
    margin: 0 0 22px;
    display: flex;
    align-items: center;
    justify-content: center;
    .iconfont {
      color: #fff;
      margin-left: 5px;
    }
    .el-upload__tip {
      margin-left: -14px;
    }
  }
  .member-first {
    p {
      font-size: 14px;
      font-weight: 400;
      color: #999999;
      line-height: 22px;
      &:first-child {
        font-size: 16px;
        font-weight: 400;
        line-height: 20px;
        color: #3c3c43;
      }
    }
  }
  .member-two {
    margin-top: 18px;
    p:first-child {
      font-size: 16px;
      font-weight: 400;
      line-height: 20px;
      color: #3c3c43;
    }
    .mt-title {
      display: flex;
      margin-bottom: 10px;
      i {
        position: relative;
        top: 2px;
        margin-left: 6px;
      }
    }
    // h4 {
    //   margin-bottom: 10px;
    // }
  }
  .member-upload {
    width: 410px;
    height: 170px;
    background: #ffffff;
    border-radius: 8px;
    border: 1px solid #dedede;
    .start-m-up {
      padding-top: 55px;
      width: 165px;
      margin: 0 auto;
      font-size: 14px;
      text-align: center;
      .start-member-btn {
        width: 130px;
        height: 40px;
      }
    }
  }
}
.common-introduce-popover .common-introduce div {
  margin-bottom: 20px;
}
.common-introduce-popover {
  width: 398px;
  background: #fff;
  box-shadow: 0px 0px 20px 0px rgba(175, 175, 175, 0.44);
  border-radius: 8px;
  z-index: 9;
  // padding: 24px;
  padding: 0;
  box-sizing: border-box;
  .popper__arrow {
    display: none;
  }
}
.member-drop.el-dropdown-menu {
  border-radius: 4px;
  overflow: hidden;
}
.role-name {
  display: inline-block;
  width: 50px;
}
.role-p {
  li {
    height: 45px;
    border-bottom: 1px solid #e7e7e7;
    box-sizing: border-box;
    line-height: 44px;
    font-size: 14px;
    font-weight: 400;
    color: #424244;
    cursor: pointer;
    text-align: center;
    &.active,
    &:hover {
      color: $activeColor;
    }
    &:last-child {
      border: none;
    }
  }
}
.mc-con {
  // .el-table td,
  // .el-table th {
  //   padding: 4px 0;
  // }
  .avator-img {
    border-radius: 50%;
    position: relative;
    top: 2px;
  }
}
.info-upload {
  text-align: left;
  line-height: 30px;
  padding: 10px;
}
.head-photo{
    max-width: 35px;
}
</style>
